import { useEffect, useState } from "react";
import { faMobileAlt, faStopwatch, faTabletAlt, faArrowRight } from "@fortawesome/free-solid-svg-icons";

import { Header } from "../../components/header/header";
import { MobiInfoUnit } from "../../components/services/mobi-info";
import { ServiceHeader } from "../../components/services/service-header";
import { MotionFrame } from "../../components/utilities/framer";
import { mobileStacks, mobiProcesses } from "../../_helpers/mock-data";
import { GenLeft } from "../../components/utilities/service-framer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MobileStack } from "../../components/services/mobi-stack";
import { useCases } from "../../_helpers/mobi-use";
import { MobileUseCase } from "../../components/services/mobi-service";
import { Footer } from "../../components/footer/footer";
import { MobileDevDialog } from "../../components/action-dialogs/mobi-actions";



export const MobileDevelopMent = () => {

    const [showDialog, setShowDialog] = useState(false);

    const isOption = new URLSearchParams(window.location.search).get("options");

    useEffect(() => {
        isOption ? setShowDialog(true): setShowDialog(false);
    }, [isOption])

    return (
        <div className="rand-page">
            <Header pageTitle={"Mobile Development"}/>
            <MobileDevDialog 
                toggleClose={() => setShowDialog(false)}
                visible={showDialog}
            />
            <ServiceHeader
                gradText={"Smart Mobile"}
                normText={"Applications"}
                descr={"Create intelligent mobile experiences that understand, learn, and evolve with your users through advanced AI integration."}
                descrImg={"/images/mobile-development.jpeg"}
                fBtnCap={"Start Building"}
                sBtnCap={"View Apps"}
                fColor={"#850868ff"}
                sColor={"#c61585ff"}
                onStart={() => setShowDialog(true)}
            />
            <MotionFrame>
                <div className="page-sub-cap">
                    <span className="norm-text">Multi-Platform</span>
                    <span className="gradient-text">Excellence</span>
                </div>
                <div className="descr flx-rw-c">
                    Deploy your AI-powered applications across all major platforms and devices
                </div>
            </MotionFrame>
            <div className="services-box">
                <MobiInfoUnit
                    icon={faMobileAlt}
                    topic={"IOS & Android"}
                    textDesc={"Native and cross-platform apps with AI-powered features"}
                />
                <MobiInfoUnit
                    icon={faTabletAlt}
                    topic={"Tablet Optimisation"}
                    textDesc={"Responsive designs that scale beautifully across all devices"}
                />
                <MobiInfoUnit
                    icon={faStopwatch}
                    topic={"Wearable Apps"}
                    textDesc={"Smart watch applications with intelligent health monitoring"}
                />
            </div>
            <MotionFrame>
                <div className="page-sub-cap">
                    <span className="gradient-text">AI-Powered</span>
                    <span className="norm-text">Features</span>
                </div>
            </MotionFrame>
            <div className="services-box">
                {mobiProcesses.map((process, indx) => (
                    <GenLeft key={indx}>
                        <div className="process-unit">
                            <div className="pnk-bg mobi-proc-circle">
                                <FontAwesomeIcon icon={process.icon} />
                            </div>
                            <div className="process-caption">{process.caption}</div>
                            <div className="process-descr">{process.descr}</div>
                        </div>
                    </GenLeft>
                ))}
            </div>
            <MotionFrame>
                <div className="page-sub-cap">
                    <span className="norm-text">Advanced</span>
                    <span className="gradient-text">Technologies</span>
                </div>
            </MotionFrame>
            <div className="services-box">
                {mobileStacks.map((obj, k) => (
                    <MobileStack stack={obj} key={k} />
                ))}
            </div>
            <MotionFrame>
                <div className="page-sub-cap">
                    <span className="norm-text">Mobile App</span>
                    <span className="gradient-text">Use Cases</span>
                </div>
            </MotionFrame>
            <div className="services-box">
                {useCases.map((useCase, k) => (
                    <MobileUseCase
                        caption={useCase.caption}
                        message={useCase.message}
                        key={k}
                    />
                ))}
            </div>
            <GenLeft>
                <div className="offer-bx glassy-effect">
                    <div className="q-cap">
                        <span className="norm-text of-cap">Build the</span>
                        <span className="gradient-text of-cap"> Future </span>
                        <span className="norm-text of-cap">of Mobile</span>
                    </div>
                    <div className="descr">
                        Create intelligent mobile experiences that users will love and remember
                    </div>
                    <div className="bttn">
                        <button className="pnk-of-btn">
                            <span className="of-btn-txt">Launch Your App</span>
                            <FontAwesomeIcon icon={faArrowRight} />
                        </button>
                    </div>

                </div>
            </GenLeft>
            <Footer />
        </div>
    )
}